import http from 'services/http';
import type { CoachLocale, GoalInput, ReminderResult, ReminderSettings, ReminderUpdate, SessionReview, StudyPlan, TodayPlan } from './types';

/** Null when the account has no learner profile, so the caller shows nothing. */
export async function getTodayPlan(signal?: AbortSignal): Promise<TodayPlan | null> {
  const { data } = await http.request.get<{ data: TodayPlan | null }>('/api/study-plan/me/today', { signal });
  return data.data;
}

/** Null when the account has no goal yet. */
export async function getStudyPlan(signal?: AbortSignal): Promise<StudyPlan | null> {
  const { data } = await http.request.get<{ data: StudyPlan | null }>('/api/study-plan/me', { signal });
  return data.data;
}

type SavedGoal = { learnerProfile: NonNullable<import('modules/auth/types').IEntity.User['learnerProfile']> };

export async function saveGoal(input: GoalInput): Promise<SavedGoal> {
  const { data } = await http.request.put<{ data: SavedGoal }>('/api/study-plan/me/goal', input);
  return data.data;
}

/** Null when there is no review to show: not graded yet, or the author hides results. */
export async function getSessionReview(attemptId: string, signal?: AbortSignal): Promise<SessionReview | null> {
  const { data } = await http.request.get<{ data: SessionReview | null }>(`/api/study-plan/reviews/${encodeURIComponent(attemptId)}`, { signal });
  return data.data;
}

export async function requestCoachNote(attemptId: string, locale: CoachLocale): Promise<SessionReview | null> {
  const { data } = await http.request.post<{ data: SessionReview | null }>(`/api/study-plan/reviews/${encodeURIComponent(attemptId)}/coach`, { locale });
  return data.data;
}

export async function getReminderSettings(signal?: AbortSignal): Promise<ReminderSettings> {
  const { data } = await http.request.get<{ data: ReminderSettings }>('/api/study-reminders/me', { signal });
  return data.data;
}

export async function updateReminder(input: ReminderUpdate): Promise<ReminderResult> {
  const { data } = await http.request.patch<{ data: ReminderResult }>('/api/study-reminders/me', input);
  return data.data;
}
